import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input,Row, Col,Container } from "reactstrap";
import { TimePicker } from "react-time-picker";
import Select from "react-select";
import MenuItem from "react-select";
import { render } from "@testing-library/react";
import "../../../style/calendarclass.css";
import moment from "moment";
import { Table, Checkbox } from "semantic-ui-react";
import api from "../../../apis/api";
import {
  useEmpListAssignConfigMail,
  SelectedEmpConfigMail,
  useEmpListAssignEmpConfigMail,
} from "../../../components/employee/index";
import TableWithSortPagtn from "../../../components/common/TableWithSortPagtn";
import Notifications from "../../../components/common/Notifications";
const getEmpId = (el) => {
  if (!el) return 0;
  const id = el.toEmpId || el.bccEmpId || el.ccEmpId || el.employeeId;
  return id && id !== "null" && id !== "undefined" ? parseInt(id) : 0;
};
const FormFieldEmployeeWise = React.memo((props) => {
  const { inputFields, formValidation ,intimeval,outtimeval,halfdayworkval,fulldayworkval,departmentList,emplist,activeTab} = props;
  const [inputFieldsArr, setInputFieldsArr] = useState(null);
const[desoptions , setOptions] =useState([{}]);
const [departmentId,setdepartmentId] =useState("");
const [isTo,setisTo] =useState(false);
const [isBcc,setisBcc] =useState(false);
const [isCc,setisCc] =useState(false);
const [isdirect,setisdirect]=useState(false);
const [istypemail,setistypemail]=useState(false);
const [empData, setEmpData] = useState([]);
const [selectedEmp, setSelectedEmp] = useState([]);
const [selectedEmpWise, setSelectedEmpWise] = useState([]);
const [selectedBccEmp, setSelectedBccEmp] = useState([]);
const [selectedCcEmp, setSelectedCcEmp] = useState([]);
const [selectedFromEmp, setSelectedFromEmp] = useState([]);
const [empArr, setempArr] = useState([]);
const [type,settype] =useState("");
const [selectedToEmp, setSelectedToEMp] = useState([]);
const [selectedBccEmpComma, setSelectedBccEMpComma] = useState([]);
const [selectedCcEmpComma, setSelectedCcEMpComma] = useState([]);
const [selectedFromEmpComma, setSelectedFromEmpComma] = useState([]);
const [error, setError] = useState(null);
let options=[];

useEffect(()=>{   
  setempArr(emplist);
  setEmpData(emplist);
},[emplist]);

  const reloadSettings = async () => {
    if (selectedFromEmpComma.length === 1) {
      let array = [];
      const empId = selectedFromEmpComma[0];
      await api.dbLeaveTypes().GetAllMailSendingSettings(0, parseInt(empId)).then((res) => array.push(res.data));
      
      const filterTo = array[0].filter((item) => item.isTo === true && item.configurationType == (activeTab=="ForLeave" ? 1: 2));
      const filterBcc = array[0].filter((item) => item.isBcc === true && item.configurationType == (activeTab=="ForLeave" ? 1: 2));
      const filterCc = array[0].filter((item) => item.isCc === true && item.configurationType == (activeTab=="ForLeave" ? 1: 2));
      
      setSelectedBccEmp(filterBcc);
      setSelectedCcEmp(filterCc);
      setSelectedEmp(filterTo);
      
      let tocomm = [];
      let bcccomm = [];
      let cccomm = [];
      
      filterTo.map(function (hol){
        tocomm.push(getEmpId(hol));     
      });
      filterBcc.map(function (hol){
        bcccomm.push(getEmpId(hol));
      });
      filterCc.map(function (hol){
        cccomm.push(getEmpId(hol));     
      });
      
      setSelectedToEMp(tocomm);
      setSelectedBccEMpComma(bcccomm);
      setSelectedCcEMpComma(cccomm);

      const hasDirectReport = filterTo.some((item) => item.isDirectReport === true);
      setisdirect(hasDirectReport);
      setistypemail(filterTo.some((item) => item.isTo === true && item.isDirectReport !== true));
    } else {
      setSelectedBccEmp([]);
      setSelectedCcEmp([]);
      setSelectedEmp([]);
      setSelectedToEMp([]);
      setSelectedBccEMpComma([]);
      setSelectedCcEMpComma([]);
      setisdirect(false);
      setistypemail(false);
    }
  };

  useEffect(() => {
    reloadSettings();
  }, [selectedFromEmpComma, activeTab]);
   inputFields.map(function (desig) {
    if(desig.type=="multipleselect" && desig.option.length >0)
    {
      desig.option.map((el,i) =>{
       options.push({value: el.designationId, label: el.designationName }); 
      })
     
    }

  })
 
  let intim=moment(intimeval, "hhmma").format("HH:mm");
  let outtim=moment(outtimeval, "hhmma").format("HH:mm");
  const handleOnchangeConfigMail =React.useCallback((depId) =>{
    setdepartmentId(depId);
  })
  const setAllEmployee =React.useCallback(() =>{
    const fetchApi = async () => {
      let array=[];
      await api.employee().getAll().then((res) => array.push(res.data.filter(emp => emp.isActive === true)));
      setEmpData(array[0]);
      setempArr(array[0]);
    }
    
    fetchApi();
  })
  const handleTo =React.useCallback((depId) =>{
   setisTo(true);
   setisBcc(false);
   setisCc(false);
   settype(1);
  })
  const handleBcc =React.useCallback((depId) =>{
    setisTo(false);
   setisBcc(true);
   setisCc(false);
   setistypemail(false);
   settype(2);
   setAllEmployee();
  })
  const handleCC =React.useCallback((depId) =>{
    setisTo(false);
   setisBcc(false);
   setisCc(true);
   setistypemail(false);
   settype(3);
   setAllEmployee();
  })
  const handleOnchangeType =React.useCallback((depId) =>{
    if(depId==1)
    {
      setisdirect(true);
      setistypemail(false);
    }
    else
    {
      setisdirect(false);
      setistypemail(true);
      const fetchApi = async () => {
        let array=[];
        await api.employee().getAll().then((res) => array.push(res.data.filter(emp => emp.isActive === true)));
        setEmpData(array[0]);
        setempArr(array[0]);
      }
      
      fetchApi();
    }

 
  },[departmentId]);
  const handleSelectedFromEmp = React.useCallback((emp) => {
    let filterEmp = selectedFromEmp.filter((el)=>el.employeeId == emp.employeeId);
    if(filterEmp.length == 0){
      setSelectedFromEmp((precState) => [...precState, emp]);
      setSelectedFromEmpComma((precState) => [...precState, emp.employeeId]);
    }
  },[selectedFromEmp]);
  const handleSelectedEmp = React.useCallback((emp, ty) => {
    const empId = getEmpId(emp);
    const inTo = selectedEmp.some((el) => getEmpId(el) === empId);
    const inBcc = selectedBccEmp.some((el) => getEmpId(el) === empId);
    const inCc = selectedCcEmp.some((el) => getEmpId(el) === empId);

    if (inTo || inBcc || inCc) {
      let role = "";
      if (inTo) role = "To";
      else if (inBcc) role = "Bcc";
      else if (inCc) role = "Cc";
      setError({ message: `${emp.employeeName} is already assigned as '${role}'!`, status: 500 });
      return;
    }

    if (ty == 1) {
      setSelectedEmp((precState) => [...precState, emp]);
      setSelectedToEMp((precState) => [...precState, empId]);
    } else if (ty == 2) {
      setSelectedBccEmp((precState) => [...precState, emp]);
      setSelectedBccEMpComma((precState) => [...precState, empId]);
    } else if (ty == 3) {
      setSelectedCcEmp((precState) => [...precState, emp]);
      setSelectedCcEMpComma((precState) => [...precState, empId]);
    } else if (ty == 0) {
      let filterEmp = selectedFromEmp.filter((el) => getEmpId(el) === empId);
      if (filterEmp.length == 0) {
        setSelectedFromEmp((precState) => [...precState, emp]);
      }
    }
  }, [selectedEmp, selectedBccEmp, selectedCcEmp, selectedFromEmp, setError]);
  const handleSelectAllEmp = React.useCallback(
    (e) => {
      let checkBox = e.target.checked;
      let tempArr = [];
      let tempArrIds = [];
      if (checkBox) {
        empData.map((employee) => {
          tempArr.push(employee);
          tempArrIds.push(employee.employeeId);
        });
        setSelectedFromEmp(tempArr);
        setSelectedFromEmpComma(tempArrIds);
      } else {
        setSelectedFromEmp([]);
        setSelectedFromEmpComma([]);
      }
    },
    [empData]
  );
  const handleSelectAllBccEmp = React.useCallback(
    (e) => {
      let checkBox = e.target.checked;
      let tempArr = [];
      let tempArrIds = [];
      if (checkBox) {
        empData.map((employee) => {
          tempArr.push(employee);
          tempArrIds.push(employee.employeeId);
        });
        setSelectedBccEmp(tempArr);
        setSelectedBccEMpComma(tempArrIds);
      } else {
        setSelectedBccEmp([]);
        setSelectedBccEMpComma([]);
      }
    },
    [empData]
  );
  const handleSelectAllCcEmp = React.useCallback(
    (e) => {
      let checkBox = e.target.checked;
      let tempArr = [];
      let tempArrIds = [];
      if (checkBox) {
        empData.map((employee) => {
          tempArr.push(employee);
          tempArrIds.push(employee.employeeId);
        });
        setSelectedCcEmp(tempArr);
        setSelectedCcEMpComma(tempArrIds);
      } else {
        setSelectedCcEmp([]);
        setSelectedCcEMpComma([]);
      }
    },
    [empData]
  );
  const searchEmployee = React.useCallback(
    (searchVal,pvalue) => {
      let tempArr = [];
      if (searchVal !== "") {
        empArr.filter((el) =>
        el.employeeName !==null ?  (el.employeeName.toLowerCase().indexOf(searchVal.toLowerCase()) !==
          -1
            ? tempArr.includes(el)
              ? null
              : tempArr.push(el)
            : null) : null
        );
       if(pvalue ==1)
       {
        setSelectedFromEmp(tempArr);
       }
       else{
 setEmpData(tempArr);
       }
        
      } else {
        setEmpData(empArr);
      }
    },
    [empArr,setEmpData]
  );
  const delSelectedEmp = React.useCallback(
    (empId) => {
      const targetId = parseInt(empId);
      let filterArr = selectedEmp.filter((el) => getEmpId(el) !== targetId);
      setSelectedEmp(filterArr);
      let filterArrIds = selectedToEmp.filter((id) => id !== targetId);
      setSelectedToEMp(filterArrIds);
    },
    [selectedEmp, selectedToEmp]
  );
  const delSelectedFromEmp = React.useCallback(
    (empId) => {
      const targetId = parseInt(empId);
      let filterArr = selectedFromEmp.filter((el) => getEmpId(el) !== targetId);
      setSelectedFromEmp(filterArr);
      let filterArrIds = selectedFromEmpComma.filter((id) => id !== targetId);
      setSelectedFromEmpComma(filterArrIds);
    },
    [selectedFromEmp, selectedFromEmpComma]
  );
  const delSelectedBccEmp = React.useCallback(
    (empId) => {
      const targetId = parseInt(empId);
      let filterArr = selectedBccEmp.filter((el) => getEmpId(el) !== targetId);
      setSelectedBccEmp(filterArr);
      let filterArrIds = selectedBccEmpComma.filter((id) => id !== targetId);
      setSelectedBccEMpComma(filterArrIds);
    },
    [selectedBccEmp, selectedBccEmpComma]
  );
  const delSelectedCcEmp = React.useCallback(
    (empId) => {
      const targetId = parseInt(empId);
      let filterArr = selectedCcEmp.filter((el) => getEmpId(el) !== targetId);
      setSelectedCcEmp(filterArr);
      let filterArrIds = selectedCcEmpComma.filter((id) => id !== targetId);
      setSelectedCcEMpComma(filterArrIds);
    },
    [selectedCcEmp, selectedCcEmpComma]
  );
  const handleAddMailSettings = async () =>{
    let formData = {
      departmentId: 0,
      employeeId:String(selectedFromEmpComma),
      toEmpId: String(selectedToEmp),
      bccEmpId:  String(selectedBccEmpComma),
      ccEmpId:  String(selectedCcEmpComma),
      isdirectReport: isdirect,
    };
    if(selectedFromEmpComma.length === 0 && selectedToEmp.length === 0 && selectedBccEmpComma.length === 0 && selectedCcEmpComma.length === 0)
    {
      setError({ message: "Enter Details...", status: 500 });
    }
    else
    {
      if(activeTab === "ForLeave")
      {
        await api.dbLeaveTypes().AddEditMailSendingSettings(formData);
      }
      else
      {
        await api.dbLeaveTypes().AddEditMailSendingSettingsForTimesheet(formData);
      }
      await reloadSettings();
      setError({ message: "Mail settings assigned successfully!", status: 200 });
    }
  }
// const options = [
//   { value: "Spring", label: "Spring" },
//   { value: "Summer", label: "Summer" },
//   { value: "Autumn", label: "Autumn" },
//   { value: "Winter", label: "Winter" }
// ];
const { thead, trow } = useEmpListAssignConfigMail(empData, handleSelectedEmp,type);
const { thead1, trow1 } = useEmpListAssignEmpConfigMail(empData, handleSelectedFromEmp);
  return (
    <div>
    

    <Fragment>
      <Container className="assign-rewards">
     
              <div className="newdiv">
               <Row className="top-row">
      
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
              <Col>
                {" "}
 <div >
  <h5>Employee List</h5>
                {/* <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value,1)}
                />
              </Col> */}
              <br/>
              
              <TableWithSortPagtn
                thead={thead1}
                trow={trow1}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllEmp} />
                Select All
              </Label>
            </div>
           
              </Col>
              
              </Row>
              </Col>
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
            <SelectedEmpConfigMail
              selectedEmp={selectedFromEmp}
              delSelectedEmp={delSelectedFromEmp}
              type={0}
            ></SelectedEmpConfigMail> 
              </Row>
              </Col>
              </Row>
              </div>
        <Row className="top-row">
          <Col xs={12} sm={2} md={2} lg={2}>
            <Row>
              <Col>
                {" "}
                <Label check >
                  <Input type="radio"  name="radio2" onClick={handleTo}/> To
                </Label><br/>
                <Label check >
                  <Input type="radio"  name="radio2" onClick={handleBcc}/> Bcc
                </Label><br/>
                <Label check >
                  <Input type="radio"  name="radio2" onClick={handleCC}/> Cc
                </Label>
    {/* <input type="checkBox" onChange={handleTo} checked={isTo}
    /> <Label>To</Label>
  <br/>
    <input type="checkBox" onChange={handleBcc} checked={isBcc}
    /> <Label>BCC</Label>
<br/>
    <input type="checkBox" onChange={handleCC} checked={isCc}
    /> <Label>CC</Label>
<br/> */}
              </Col>
              </Row>
              </Col>
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
              <Col>
                {" "}
                {isTo == true ? (<div> <Input
                type="select"
                name="select"
                value={isdirect ? 1 : (istypemail ? 2 : "")}
                onChange={(e) => handleOnchangeType(e.target.value)} 
                // filter(n=>n.departmentId == selectedCategoryId)
              >
                <option value="">select Type</option>
               <option value={1}>Direct Report</option>
               <option value={2}>Type MailId</option>
              </Input><br/></div> ) : null } {istypemail ==true ? (     <div >
                <h5>Employee List</h5>
                <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
              </Col><br/>
              
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllEmp} />
                Select All
              </Label>
            </div>) : null}
                {isBcc == true ? ((     <div >
                  <h5>Employee List</h5>
                <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
              </Col><br/>
              
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllBccEmp} />
                Select All
              </Label>
            </div>)) : null}
                {isCc == true ? ((     <div >
                  <h5>Employee List</h5>
                <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
              </Col> <br/>
             
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllCcEmp} />
                Select All
              </Label>
            </div>)) : null}
              </Col>
              
              </Row>
              </Col>
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
            {istypemail ==true ? ( <SelectedEmpConfigMail
              selectedEmp={selectedEmp}
              delSelectedEmp={delSelectedEmp}
              type={1}
            ></SelectedEmpConfigMail> ) : null }
            {isBcc == true ? (<SelectedEmpConfigMail
              selectedEmp={selectedBccEmp}
              delSelectedEmp={delSelectedBccEmp}
              type={2}
            ></SelectedEmpConfigMail>) : null }
            {isCc == true ? (<SelectedEmpConfigMail
              selectedEmp={selectedCcEmp}
              delSelectedEmp={delSelectedCcEmp}
              type={3}
            ></SelectedEmpConfigMail>) : null }
              </Row>
              </Col>
              </Row>
            
              </Container>
              <Button
        // color="danger"
        className="assign-reward-btn-submit float-right"
        // outline
        onClick={handleAddMailSettings}
      >
        <i className="far fa-hand-point-up"></i> Assign
      </Button>
      <Notifications notifications={error}></Notifications>
              </Fragment>
    </div>
  );
});

export default FormFieldEmployeeWise;
